import { Redirect, Switch } from 'react-router-dom';

import { SubscriptionBlockCreatePage, SubscriptionBlockDetailPage, SubscriptionsPage } from 'domains/subscriptions';

import PrivateRoute, { PrivateRouteNoFrame } from '../PrivateRoute';

export function SubscriptionRoutes() {
  return (
    <Switch>
      <PrivateRoute component={SubscriptionsPage} exact path="/subscriptions" />

      {/* Block creation wizard renders as a fullscreen Dialog and must escape the AppFrame
          (sidebar uses MUI zIndex 1300, above Radix Dialog's z-50). Mounting without the
          frame avoids the z-index war and mirrors the onboarding wizard pattern. */}
      <PrivateRouteNoFrame component={SubscriptionBlockCreatePage} path="/subscriptions/blocks/create" />

      <PrivateRoute component={SubscriptionBlockDetailPage} exact path="/subscriptions/blocks/:blockUuid" />

      {/* Permalink support: the legacy /subscription routes were removed, but bookmarks and
          links in the wild still point there. Kept indefinitely — see spec 010 §7.3. */}
      <Redirect from="/subscription/(payment-history|invoice-data)?/(edit)?" to="/subscriptions" />
    </Switch>
  );
}
